module.exports = __webpack_public_path__ + "img/Jeremy Ausmus.4afd8130.png";